import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import Academics from './components/Academics';
import Contact from './components/Contact';
import NIRF2025 from './components/NIRF2025';
import DepartmentTemplate from './components/DepartmentTemplate';
import NotFound from './components/NotFound';
import Committees from './components/Committees';
import Suspended from './components/Suspended';
import { SITE_SUSPENDED } from './config/suspension';

// ScrollToTop component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  // When suspended, nothing else on the site is reachable: the router, header,
  // footer and every page are never mounted, so any URL shows only this notice.
  if (SITE_SUSPENDED) {
    return <Suspended />;
  }

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/academics" element={<Academics />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/nirf-2025" element={<NIRF2025 />} />
          <Route path="/committees" element={<Committees />} />
          {/* Redirect old incorrect department URLs to correct ones */}
          <Route path="/departments/opthalmology" element={<Navigate to="/departments/ophthalmology" replace />} />
          <Route path="/departments/pulmonoary-medicine" element={<Navigate to="/departments/pulmonary-medicine" replace />} />
          <Route path="/departments/radation-oncology" element={<Navigate to="/departments/radiation-oncology" replace />} />
          <Route path="/departments/:departmentId" element={<DepartmentTemplate />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 